import { WSGrid, WSList } from "@wingspanhq/fe-component-library";
import { DataItem } from "../../../shared/components/DataItem";

export const InstantPayoutPayoutCA: React.FC = () => {
  return (
    <WSList gap="XL">
      <WSGrid gutter="XL">
        <WSGrid.Item span="6">
          <DataItem label="Instant payout service" value="Interac" />
        </WSGrid.Item>
        <WSGrid.Item span="6">
          <DataItem
            label="Transaction maximum"
            value={25000}
            formatterOptions={{ currency: "CAD" }}
          />
        </WSGrid.Item>
      </WSGrid>
      <DataItem
        label="Delivery"
        value="Near real time (up to 90 mins) and subject to window of 05:00 hrs ET to 22:30 hrs ET"
      />
    </WSList>
  );
};
